// removed by extract-text-webpack-plugin
module.exports = {"fieldSet":"_2bcCV","horizontal":"_2Yuef","vertical":"_2LS72","labelWrapper":"_3H4To","inputWrapper":"_3CZcy"};


//////////////////
// WEBPACK FOOTER
// ../src/components/FieldSet/FieldSet.css
// module id = 515
// module chunks = 0